import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a26c4ef38ca120014e804e1_1780941875605_08d2c580/forge/src/app/behavior-intelligence/page.tsx");
